import { LABELS } from "~/resources/Labels";
import { TableHeaderType } from "../types/TableHeaderType";

export const CloudEnviromentHeader: TableHeaderType[] = [
    {
      label: LABELS.Provider,
      key: 'cloudProvider.cloudProviderName',
      id: 'cloudProvider.cloudProviderName',
      sortable: true,
    },
    {
      label:'Name',
      key: 'environmentName',
      id: 'environmentName',
      sortable: true,
    },
    {
      label:'Iac',
      key: 'iac',
      id: 'iac',
      sortable: true,
    },
    {
      id: 'environmentDescription',
      label: LABELS.Description,
      sortable: true,
      key: 'environmentDescription',
    },
  ];
